// components/loading/CardLoadingSpinner.tsx
import { Loader2 } from "lucide-react";

interface CardLoadingSpinnerProps {
  message?: string;
}

export const CardLoadingSpinner = ({ 
  message = "Carregando..." 
}: CardLoadingSpinnerProps) => {
  return (
    <div className="absolute inset-0 bg-white/70 flex items-center justify-center z-10 rounded-lg">
      <div className="flex flex-col items-center gap-2">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <span className="text-sm text-muted-foreground">{message}</span>
      </div>
    </div>
  );
};